import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import {NavigationService} from "../../../shared/services/navigation.service";
import {ThemeService} from '../../services/theme.service';
import {Subscription} from "rxjs";
import { SidenavComponent } from '../sidenav/sidenav.component';

@Component({
    selector: 'app-sidebar-side',
    templateUrl: './sidebar-side.component.html',
    standalone: true,
    imports: [
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    SidenavComponent
]
})
export class SidebarSideComponent implements OnInit, OnDestroy {
	private navService = inject(NavigationService);
	themeService = inject(ThemeService);

	public menuItems: any[];
	public hasIconTypeMenuItem: boolean;
	public iconTypeMenuTitle: string;
	private menuItemsSub: Subscription;

	ngOnInit() {
		this.iconTypeMenuTitle = this.navService.iconTypeMenuTitle;
		this.menuItemsSub = this.navService.menuItems$.subscribe(menuItem => {
			this.menuItems = menuItem;
			//Checks item list has any icon type.
			this.hasIconTypeMenuItem = !!this.menuItems.filter(item => item.type === 'icon').length;
		});
	}

	ngOnDestroy() {
		if (this.menuItemsSub) {
			this.menuItemsSub.unsubscribe()
		}
	}

}
